import type { TourProgress } from './types';

// Tour progress is persisted per user in localStorage so a paused tour can be
// resumed on a later visit. Keyed by a stable user identifier (subject/email)
// so switching accounts on the same browser keeps progress separate.
const KEY_PREFIX = 'zta_tours_v1';

export type ProgressMap = Record<string, TourProgress>;

function storageKey(userKey: string): string {
  return `${KEY_PREFIX}:${userKey}`;
}

export function loadProgress(userKey: string): ProgressMap {
  try {
    const raw = localStorage.getItem(storageKey(userKey));
    return raw ? (JSON.parse(raw) as ProgressMap) : {};
  } catch {
    // Private mode / disabled storage / corrupt JSON — start clean.
    return {};
  }
}

export function saveProgress(userKey: string, map: ProgressMap): void {
  try {
    localStorage.setItem(storageKey(userKey), JSON.stringify(map));
  } catch {
    // Quota exceeded or storage unavailable — progress just won't persist.
  }
}
